function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m497 0h-46l-30 30v30l30 31h42.407l18.593-31v-45c0-8.286-6.716-15-15-15z",
  fill: "#ff4c04"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m391 0-30 30v30l30 31h60v-91z",
  fill: "#fdbf00"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m331 0-30 30v30l30 31h60v-91z",
  fill: "#3aaaff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m256 0h-241c-8.291 0-15 6.709-15 15v45l30 31h226 75v-91z",
  fill: "#6e6e6e"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m256 0h75v91h-75z",
  fill: "#444"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m256 60h-256v286c0 8.399 6.599 15 15 15h241 241c8.401 0 15-6.601 15-15v-286z",
  fill: "#f5f0eb"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m512 60v286c0 8.399-6.599 15-15 15h-241v-301z",
  fill: "#dcd2cd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m256 121c-107.52 0-195 87.48-195 195s87.48 196 195 196 195-88.48 195-196-87.48-195-195-195z",
  fill: "#27d8f6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m451 316c0-107.52-87.48-195-195-195v391c107.52 0 195-88.48 195-196z",
  fill: "#3aaaff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m389.484 301c-7.011-62.325-56.159-111.473-118.484-118.484l-15 28.484-15-28.484c-62.325 7.011-111.473 56.159-118.484 118.484l28.484 15-28.484 15c7.011 62.325 56.158 111.473 118.484 118.484l15-28.484 15 28.484c62.325-7.011 111.473-56.158 118.484-118.484l-28.484-15z",
  fill: "#f5f0eb"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m389.484 331-28.484-15 28.484-15c-7.011-62.325-56.159-111.473-118.484-118.484l-15 28.484v210l15 28.484c62.325-7.011 111.473-56.159 118.484-118.484z",
  fill: "#dcd2cd"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m181 316c0-8.291-6.709-15-15-15h-43.484c-.562 4.99-1.516 9.864-1.516 15s.954 10.01 1.516 15h43.484c8.291 0 15-6.709 15-15z",
  fill: "#6e6e6e"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m389.484 301h-43.484c-8.291 0-15 6.709-15 15s6.709 15 15 15h43.484c.562-4.99 1.516-9.864 1.516-15s-.954-10.01-1.516-15z",
  fill: "#444"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m256 181c-5.136 0-10.01.954-15 1.516v43.484c0 8.291 6.709 15 15 15s15-6.709 15-15v-43.484c-4.99-.562-9.864-1.516-15-1.516z",
  fill: "#6e6e6e"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m256 391c-8.291 0-15 6.709-15 15v43.484c4.99.562 9.864 1.516 15 1.516s10.01-.954 15-1.516v-43.484c0-8.291-6.709-15-15-15z",
  fill: "#6e6e6e"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m271 226v-43.484c-4.99-.562-9.864-1.516-15-1.516v60c8.291 0 15-6.709 15-15z",
  fill: "#444"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m271 406c0-8.291-6.709-15-15-15v60c5.136 0 10.01-.954 15-1.516z",
  fill: "#444"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m296.605 335.395-25.605-25.606v-23.789c0-8.291-6.709-15-15-15s-15 6.709-15 15v30c0 3.984 1.582 7.793 4.395 10.605l10.605 10.606 19.395 19.395c5.859 5.859 15.352 5.859 21.211 0s5.859-15.352-.001-21.211z",
  fill: "#ff712f"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m296.605 356.605c5.859-5.859 5.859-15.352 0-21.211l-25.605-25.605v-23.789c0-8.291-6.709-15-15-15v66.211l19.395 19.395c5.859 5.859 15.351 5.859 21.21-.001z",
  fill: "#ff4c04"
});

var Svg013Time = function Svg013Time(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg013Time, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/013-time.c5d02a13.svg";
export { ForwardRef as ReactComponent };